import React, { useMemo } from "react";
import { Modal } from "../../common/Modal/Modal";
import {
  PrimaryButton,
  ScrollStyles,
  SecondaryButton,
} from "../../common/common.style";
import { Box, FlexBox } from "../../primitives";
import { CardSelected } from "../../../type";
import { Price } from "../../Cards/Price";
import { Quantity } from "../../Cards/Quantity";
import { Condition } from "../../Cards/Condition";
import { Langugage } from "../../Cards/Language";
import { AiFillStar } from "react-icons/ai";
import { FiEdit2 } from "react-icons/fi";
import { CardName, SubTitle } from "./modalPublishChange.styled";
import { useCards } from "../../../context/CardsContext";
import { getPriceDifferencePercent } from "../../../utils";

interface ModalPublishChangeProps {
  setIsOpenModalPublishChange: (arg1: boolean) => void;
  cardsBoard: CardSelected[];
  onClickEditProductHandler: () => void;
}

export const ModalPublishChange = ({
  setIsOpenModalPublishChange,
  cardsBoard,
  onClickEditProductHandler,
}: ModalPublishChangeProps) => {
  const cardComplexArray = useCards();

  const commonFunctionOnCancel = () => {
    setIsOpenModalPublishChange(false);
  };

  const commonFunctionOnConfirm = () => {
    setIsOpenModalPublishChange(false);
    onClickEditProductHandler();
  };

  const sortedBoard = useMemo(() => {
    return [...cardsBoard].sort(
      (a, b) => getPriceDifferencePercent(a) - getPriceDifferencePercent(b)
    );
  }, [cardsBoard]);

  return (
    <Modal
      onClose={() => commonFunctionOnCancel()}
      modalStyle={{ maxWidth: "1400px" }}
    >
      <Box
        css={{
          fontWeight: "bold",
          textAlign: "center",
          textTransform: "uppercase",
        }}
      >
        Please, review the changes before pressing confirm
      </Box>
      <FlexBox
        css={{
          justifyContent: "space-between",
          textAlign: "left",
          marginTop: 50,
          fontWeight: "bold",
          padding: "0px 10px",
        }}
      >
        <Box css={{ width: 150 }}>Name</Box>
        <Box css={{ width: 150 }}>Details</Box>
        <Box css={{ width: 200 }}>Price</Box>
        <Box css={{ width: 100 }}>Quantity</Box>
        <Box css={{ width: 100 }}>Condition</Box>
        <Box css={{ width: 100 }}>Language</Box>
        <Box css={{ width: 24 }}>F</Box>
        <Box css={{ width: 24 }}>S</Box>
      </FlexBox>
      <Box css={{ overflow: "auto", marginTop: 20, ...ScrollStyles }}>
        <Box css={{ height: 400 }}>
          {sortedBoard.map((card, index) => {
            const foundCardComplexArray = cardComplexArray[card.id];
            return (
              <FlexBox
                key={`${card?.cardTraderId}-${index}`}
                css={{
                  justifyContent: "space-between",
                  background: index % 2 ? "#E5E7EB" : "transparent",
                  alignItems: "center",
                  padding: 10,
                  width: "100%",
                }}
              >
                <CardName>{foundCardComplexArray.name}</CardName>
                <SubTitle>{`#${foundCardComplexArray.fixed_properties.collector_number} ${foundCardComplexArray.editionCode} - ${foundCardComplexArray.editionName} ${foundCardComplexArray.card_market_ids}`}</SubTitle>
                <Box css={{ width: 200 }}>
                  <Price
                    card={card}
                    containerStyled={{ flexDirection: "row" }}
                  />
                </Box>
                <Box css={{ width: 100 }}>
                  <Quantity card={card} />
                </Box>
                <Box css={{ width: 100 }}>
                  <Condition
                    condition={card.condition}
                    originalCondition={card?.originalCondition}
                  />
                </Box>
                <Box css={{ width: 100 }}>
                  <Langugage
                    language={card.language}
                    originalLanguage={card?.originalLanguage}
                  />
                </Box>
                {card.finish === "foil" ? (
                  <AiFillStar size={24} color="#FFD700" />
                ) : (
                  <Box css={{ width: 24 }} />
                )}
                {card.signed ? (
                  <FiEdit2 size={24} color={"black"} />
                ) : (
                  <Box css={{ width: 24 }} />
                )}
              </FlexBox>
            );
          })}
        </Box>
      </Box>
      <FlexBox css={{ justifyContent: "center", gap: 20 }}>
        <PrimaryButton
          onClick={() => {
            commonFunctionOnConfirm();
          }}
        >
          <Box>PUBLISH</Box>
        </PrimaryButton>
        <SecondaryButton
          onClick={() => {
            commonFunctionOnCancel();
          }}
        >
          <Box>CLOSE</Box>
        </SecondaryButton>
      </FlexBox>
    </Modal>
  );
};
